import { useMap } from "react-leaflet";
import { useImperativeHandle, useCallback, useEffect } from "react";
import ClickHandler from "./ClickHandler";

export default function MapController({
  position,
  setPosition,
  forwardRef,
  bounds,
}) {
  const map = useMap();

  const moveMarkerAndCenter = useCallback(
    async (lat, lng) => {
      setPosition((prev) => {
        if (prev && prev[0] === lat && prev[1] === lng) return prev;
        return [lat, lng];
      });

      map.setView([lat, lng], map.getZoom());
    },
    [map, setPosition],
  );

  useEffect(() => {
    moveMarkerAndCenter(position[0], position[1]);
  }, [position, moveMarkerAndCenter]);

  const moveToMyLocation = () => {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition((pos) => {
      const { latitude, longitude } = pos.coords;
      moveMarkerAndCenter(latitude, longitude);
    });
  };

  useImperativeHandle(forwardRef, () => ({
    moveToMyLocation,

    moveToLocation: moveMarkerAndCenter,

    focusOnLocation: () => {
      if (!position) return;

      map.setView(position, 17, { animate: false });

      const mapSize = map.getSize();
      let offsetX = 0;
      let offsetY = 0;

      if (window.innerWidth > 600) {
        const sidebarWidth = mapSize.x * 0.25;
        offsetX = -sidebarWidth / 2;
      } else {
        const sidebarHeight = mapSize.y * 0.5;
        offsetY = sidebarHeight / 2;
      }

      map.panBy([offsetX, offsetY], { animate: true });
    },
  }));

  return <ClickHandler onMove={moveMarkerAndCenter} bounds={bounds} />;
}
